import { Dayjs } from "dayjs";

export interface IApiResponse {
  records: any;
  id: string;
  code: number;
  status: boolean;
  message: string;
  data: object | string;
  title: string;
}

export interface IApiResponseInvoice {
  records: any;
  id: string;
  code: number;
  status: boolean;
  message: string;
  data: object | string;
  title: string;


}

export interface IActivityHistoryApiResponse {
  records: any;
  id: string;
  code: number;
  status: boolean;
  message: string;
  data: {
    customer: any[];  // Array of customer objects (or you can create a more detailed type for customer if needed)
    emailLogs: any[]; // Array of email logs (or you can create a more detailed type for email logs if needed)
    smsLogs: any[];
    noteLogs: any[]; 
    notes: any[];// Optional field for note logs, if you decide to include them in the response
    projects: any[];
    projectLogs: any[];
    callSummaries?: any[];
    inquiryLogs?: any[]
  };
  title: string;
}

export interface IActivityHistoryProjectApiResponse {
  records: any;
  id: string;
  code: number;
  status: boolean;
  message: string;
  data: {
    customerProjects: any[];  // Array of customer objects (or you can create a more detailed type for customer if needed)
    emailLogs: any[]; // Array of email logs (or you can create a more detailed type for email logs if needed)
    smsLogs: any[];
    noteLogs: any[]; 
    notes: any[];// Optional field for note logs, if you decide to include them in the response
  callSummaries?: any[];
    inquiryLogs?: any[];
  };
  title: string;
}


export interface IApiResponseWorkOrder {
  records: any;
  id: string;
  code: number;
  status: boolean;
  message: string;
  data: {
    quoteWorkOrderCustomerId: any;
    id: string;
  };
  title: string;
}

export interface IApiLoopingResponse {
  records: any;
  // id: string;
  code: number;
  status: boolean;
  message: string;
  data: {
    id: string;
    productDetailsIsLooping: boolean;
    productsDetailsLoopingConstant: string;
  };
  title: string;
}

export interface IApiCustomerResponse {
  records: any;
  // id: string;
  code: number;
  status: boolean;
  message: string;
  data: {
    id: string;
  };
  title: string;
}

export interface IApiShopProductResponse {
  success: boolean;
  message: string;
  data?: IShopProduct[]; // array of shop products
}

export interface IUser {
  username: string;
  password: string;
}

export interface ICurrentUserCompany {
  id: number;
  name: string;
  branding_logo?: string | null;
  branding_primary_color?: string | null;
  branding_accent_color?: string | null;
}

export interface ICurrentUser {
  id: number;
  name: string | null;
  username: string;
  email: string | null;
  role: "super_admin" | "company_admin" | "content_manager" | string;
  role_label: string;
  is_active: boolean;
  company_id: number | null;
  company: ICurrentUserCompany | null;
}

export interface IAuth {
  token: string;
  user?: ICurrentUser;
}

export interface ISignageUser extends ICurrentUser {}

export interface ISignageActivity {
  id: number;
  action: string;
  subject_type: string | null;
  subject_id: number | null;
  company_id: number | null;
  company: { id: number; name: string } | null;
  user_id: number | null;
  user: { id: number; name: string } | null;
  meta: Record<string, unknown> | null;
  old_values: Record<string, unknown> | null;
  new_values: Record<string, unknown> | null;
  ip_address: string | null;
  created_at: string | null;
}

export interface ICategory {
  id: number;
  categoryName: string;
  departmentId: number;
  roleId: number;
  coursingId: number;
  servingSize: number[];
  hidePos: boolean;
  hideOnlineOrder: boolean;
  hideKiosk: boolean;
  Conversational: boolean;
  itemServiceCharge: string;
  ageRestriction: boolean;
  excludeCheckTax: boolean;
  taxeId: number;
  kitchenPrintersTypes: string;
  categoryButtonColor: string;
  categoryIsLooping: boolean;
  categoryLoopingConstant: string;
  categoryPrinterIds: number[];
  itemServiceChargeId: string;
  itemServiceChargePrice: string;
  categoryImg: string;
  isActive: boolean;
  mainCatId: number;
  parent_ids: number[];
  productCount?: number;
   loopingDetails?:{
    tableName: string;
    shortTableName: string;
    tableColumns: {
      name: string;
      type: string;
      columnField: string;
      options: string[];
      value: any;
    }[];
  };
}

export interface ISalesCategory {
  id: number;
  categoryName: string;
  roleId: number;
  coursingId: number;
  servingSize: number;
  isPosDisplay: boolean;
  // hideOnlineOrder: boolean;
  // hideKiosk: boolean;
  // Conversational: boolean;
  // itemServiceCharge: string;
  // ageRestriction: boolean;
  // excludeCheckTax: boolean;
  // taxeId: number;
  // kitchenPrintersTypes: string;
  categoryButtonColor: string;
  categoryIsLooping: string;
  categoryLoopingConstant: string;
  // categoryPrinterIds: number[];
  // itemServiceChargeId: string;
  // itemServiceChargePrice: string;
  categoryImg: string;
  isActive: boolean;
  mainCatId: number;
  parent_ids: number[];
  bgColor: string;
  orderNumber: number;
  productCount: number;
  isOnSale: number;
}

export interface ICategoryNew {
  categoryName: string;
  departmentId: string;
  roleId: number[];
  coursingId: string;
  servingSize: number[];
  hidePos: boolean;
  hideOnlineOrder: boolean;
  hideKiosk: boolean;
  Conversational: boolean;
  ageRestriction: boolean;
  excludeCheckTax: boolean;
  taxeId: string;
  categoryButtonColor: string;
  categoryIsLooping: boolean;
  categoryLoopingConstant: string;
  categoryPrinterIds: number[];
  itemServiceChargeId: string;
  itemServiceChargePrice: string;
  categoryImg: string | null;
  isActive: boolean;
  parent_ids: number[] | null;
  mainCatId: string;
}
export interface ICategoryNeww {
  categoryName: string;
  categoryImg: string;
}

export interface ICompanyDetails {
  id: number;
  companyName: string;
  companySlog: string;
  companyProvince: string;
  companyCity: string;
  companyPostalCode: string;
  companyEmail: string;
  companyMobileNumber: string;
  companyAltMobileNumber: string;
  companyWebSiteLink: string;
  companyDescription: string;
  companyFooterDetails: string;
  companyHstNo: string;
  companyStreetNumber: string;
  companyStreetName: string;
  companyPaymentMethod: string;
  CompanyLogo: string;
  CompanyWatermark: string;
  isDefault: number;
  subscription_plan?: string | null;
  subscription_status?: "trial" | "active" | "past_due" | "suspended" | "cancelled" | string | null;
  trial_ends_at?: string | null;
  trial_days_left?: number | null;
  billing_email?: string | null;
  billing_notes?: string | null;
  max_devices?: number | null;
  /** Computed fields surfaced by the backend on /company/getAll. */
  is_subscription_active?: boolean;
  subscription_inactive_reason?: string | null;
  active_billing_devices?: number;
  monthly_total?: number | null;
  openingHours?: (IOpeningHours | null)[];
  onlineOpeningHours?: (IOpeningHours | null)[];
}

export interface IAppRelease {
  id: number;
  platform: "android" | "web" | string;
  version_code: number;
  version_name: string;
  release_channel: "stable" | "beta" | string;
  apk_path: string | null;
  download_url: string | null;
  file_size: number | null;
  checksum: string | null;
  release_notes: string | null;
  is_active: boolean;
  force_update: boolean;
  created_at: string | null;
}

export interface IBillingRow {
  id: number;
  name: string;
  subscription_plan: string | null;
  subscription_status: string;
  trial_ends_at: string | null;
  trial_days_left: number | null;
  is_subscription_active: boolean;
  max_devices: number | null;
  total_devices: number;
  active_devices: number;
  disabled_devices: number;
  monthly_total: number;
  avg_device_price: number | null;
  billing_email: string | null;
}

export interface IOpeningHours {
  open: string | null;
  close: string | null;
}

export interface IDepartment {
  id: number;
  departmentName: string;
  description: string;
  DepartmentPrinterIds: number[];
}

export interface ICoursing {
  id: number;
  coursingName: string;
  priocity: string;
}

export interface ITaxes {
  id: number;
  taxName: string;
  taxType: string;
  applyTo: string;
  percentage: string;
  taxCode: string;
  isDefault: boolean;
}

export interface IRoutes {
  id: number;
  name: string;
  cities: string[]; // array of selected cities
  delivery_schedule: {
    Monday?: string;
    Tuesday?: string;
    Wednesday?: string;
    Thursday?: string;
    Friday?: string;
    Saturday?: string;
    Sunday?: string;
  };
}

export interface IProductCategory {
  id: number;
  productCatName: string;
  productCatDescription: string;
  productCatImg: string;
  isMain: boolean;
  isActive: boolean;
  mainCatId: number;
  productCategoryIsLooping: boolean;
  productCategoryIsLoopingConstant: number;
}

export interface IProductTag {
  id: number;
  tagName: string;
  isActive: boolean;
}

export interface IProductBrand {
  id: number;
  productBrandName: string;
  isActive: boolean;
}

export interface IPrinter {
  id: number;
  printerName: string;
  printerDescription: string;
}

interface ModifierGroupSelection {
  modifierGroupId: number;
  required?: boolean;
  minimum: number;
  maximum: number;
}


export interface IProduct {
  id?: number;
  productName: string;
  modelNo?: string,
  productShortDescription: string;
  productLongDescription: string;
  productConversionUnit: number[];
  saleTypeId?: number[];
  stockManagementType?: string;
  productBrandId: string;
  productCategoryId: string;
  productTagIds: number[];
  productViewOnline: boolean; 
  productViewPos?: boolean; 
  productPrinterIds: number[];
  productIcon: string;
  productImg: string;
  productButtonColor: string;
  productBarcode: string;
  productManualBarcode?: string;
  isActive: boolean;
  productDetailsIsLooping: boolean;
  productsDetailsLoopingConstant: string;
  productCanSell: boolean;
  productPrice: string;
   hasVariants: boolean;
  variantIds: string; 
  salePrice : string;
  offerPrice?: string;
  wholesaleprice?: string;
  qty?: number;
  orderNumber: string;
  mainCatId: string,
  isSerialize?:  boolean;
  isModifier?:  boolean;
  modifierGroupId: ModifierGroupSelection[],
  linkedProductId?: string;
  base_unit_id?: number | string;
  purchase_unit_id?: number | string;
  conversion_rate?: number | string;
  is_weight_based?: boolean;
  tax_group_id?: number | string;
  pos_requires_quantity?: boolean;
  stock_count?: number;
    created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
  loopingDetails?:{
    tableName: string;
    shortTableName: string;
    tableColumns: {
      name: string;
      type: string;
      columnField: string;
      options: string[];
      value: any;
    }[];
  };
}

export interface IEvent {
  id?: number;
  productName: string;
  startDateTime: Dayjs | null;
  endDateTime: Dayjs | null;
  modelNo?: string,
  productShortDescription: string;
  productLongDescription: string;
  productConversionUnit: number[];
  saleTypeId?: number[];
  stockManagementType?: string;
  productBrandId: string;
  productCategoryId: string;
  productTagIds: number[];
  productViewOnline: boolean; 
  productViewPos?: boolean; 
  productPrinterIds: number[];
  productIcon: string;
  productImg: string;
  productButtonColor: string;
  productBarcode: string;
  productManualBarcode?: string;
  isActive: boolean;
  productDetailsIsLooping: boolean;
  productsDetailsLoopingConstant: string;
  productCanSell: boolean;
  productPrice: string;
   hasVariants: boolean;
  variantIds: string; 
  salePrice : string;
  offerPrice?: string;
  qty?: number;
  orderNumber: string;
  mainCatId: string,
  isSerialize?:  boolean;
  isModifier?:  boolean;
  modifierGroupId: ModifierGroupSelection[],
  linkedProductId?: string;
  base_unit_id?: number | string;
  purchase_unit_id?: number | string;
  conversion_rate?: number | string;
  is_weight_based?: boolean;
  tax_group_id?: number | string;
  pos_requires_quantity?: boolean;
  stock_count?: number;
    created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
  loopingDetails?:{
    tableName: string;
    shortTableName: string;
    tableColumns: {
      name: string;
      type: string;
      columnField: string;
      options: string[];
      value: any;
    }[];
  };
  wpPageId?: string | number;
  eventSlug?: string;
  slug?: string;
  soldQuantity: number;
  expectingParticipants: number;
  bookingOpenAt: any;
  bookingCloseAt: any;
  includesFood: boolean;

}



export interface IVariant {
  productId: string;
  productName: string;
  productShortDescription: string;
  productLongDescription: string;
  productConversionUnit: number[];
  productBrandId: string;
  productCategoryId: string;
  productTagIds: number[];
  productViewOnline: boolean; 
  productViewPos? : boolean;
  productPrinterIds: number[];
  productIcon: string;
  productImg: string;
  productButtonColor: string;
  productBarcode: string;
  isActive: boolean;
  productDetailsIsLooping: boolean;
  productsDetailsLoopingConstant: string;
  productCanSell: boolean;
  productPrice: string;
  hasVariants: boolean;
  variantIds: string; 
  salePrice : string;
  offerPrice? : string;
  orderNumber: string;
  mainCatId: string,
  modifierGroupId: ModifierGroupSelection[],
  loopingDetails?:{
    tableName: string;
    shortTableName: string;
    tableColumns: {
      name: string;
      type: string;
      columnField: string;
      options: string[];
      value: any;
    }[];
  };
}

export interface IProductEx {
  productName: string;
  productCategoryId: string;
  mainCatId: string,
  productDetailsIsLooping: boolean;
  productsDetailsLoopingConstant: string;

}

export interface ISlotSelection {
  slotIds: number[];
  quantity: number;
  date: string;
  slotTimes: string[]; 
}

export interface IProductPopUP {
  id: string;
  productName: string;
  modelNo?: string;
  phoneType: string;
  productShortDescription: string;
  productLongDescription: string;
  productConversionUnit: number[];
  saleTypeId?: number[];
  stockManagementType?: string;
  productBrandId: number | null;
  productCategoryId: number;
  ProductCategoryLevel: number;
  productTagIds: number[];
  productViewOnline: boolean; // Assuming this should be a boolean
  productViewPos?: boolean;
  productPrinterIds: number[];
  productIcon: string;
  productImg: string;
  productButtonColor: string;
  productBarcode: string;
  isActive: boolean;
  isSerialize?: boolean;
  isModifier?: boolean;
  productPrice: string;
  salePrice : string;
  offerPrice? : string;
  wholesaleprice? : string;
  qty? : number;
  orderNumber: string;
  modifierGroupId: ModifierGroupSelection[],
  hasVariants: boolean;
  variantIds: string; 
  productDetailsIsLooping: boolean;
  productsDetailsLoopingConstant: string;
  productsDetailsLoopingProductId: string;
  stock_count?: number;
  available_stock?: number;
  phoneLoopingDetails?: {
    productId: string;
    phoneType: string;
    phoneColor: string;
    phoneLoopingId: number;
  };
  computerLoopingDetails?: {
    productId: string;
    computerModel: string;
    computerRam: string;
    computerLoopingId: number;
  };
  productCanSell: boolean;
  productMainCategoryId: string;
  loopingDetails?:{
    tableName: string;
    shortTableName: string;
    tableColumns: {
      name: string;
      type: string;
      columnField: string;
      options: string[];
      value: any;
    }[];
  };
    user_ids?: number[] | string | null;
  access_details?: { id: number; gate?: string | null }[] | string; 
}


export interface IInquiry {
  id: number;
  customer_id: string | null;
  mode?: string;
  event_type: string | null;
  event_date: string | null;
  estimated_guests: number | null;
  budget: "yes" | "not_sure" | null;
  budget_per_person: number;
  message: string | null;
  status?: number;
  isDelete: boolean;
  created_at: string;
  ctime: string;
  updated_at: string;
  customer?: ICustomer | null;
  latestFollowup?: IInquiryFollowup | null;
}

export interface IInquiryFollowup {
  id: number;
  event_inquiry_id: number;
  call_summary?: string | null;
  call_outcome?: "interested" | "not_interested" | "call_later" | null;
  next_follow_up_date?: string | null;
  priority?: "high" | "medium" | "low";
  created_by: number;
  created_at: string;
}

export interface IVariantPopUP {
  id: string;
  productId: string;
  productName: string;
  phoneType: string;
  productShortDescription: string;
  productLongDescription: string;
  productConversionUnit: number[];
  productBrandId: number | null;
  productCategoryId: number;
  ProductCategoryLevel: number;
  productTagIds: number[];
  productViewOnline: boolean; // Assuming this should be a boolean
  productViewPos : boolean;
  productPrinterIds: number[];
  productIcon: string;
  productImg: string;
  productButtonColor: string;
  productBarcode: string;
  isActive: boolean;
  productPrice: string;
  salePrice : string;
  offerPrice: string;
  orderNumber: string;
  modifierGroupId: ModifierGroupSelection[],
  hasVariants: boolean;
  variantIds: string; 
  productDetailsIsLooping: boolean;
  productsDetailsLoopingConstant: string;
  productsDetailsLoopingProductId: string;
  phoneLoopingDetails?: {
    productId: string;
    phoneType: string;
    phoneColor: string;
    phoneLoopingId: number;
  };
  computerLoopingDetails?: {
    productId: string;
    computerModel: string;
    computerRam: string;
    computerLoopingId: number;
  };
  productCanSell: boolean;
  productMainCategoryId: string;
  loopingDetails?:{
    tableName: string;
    shortTableName: string;
    tableColumns: {
      name: string;
      type: string;
      columnField: string;
      options: string[];
      value: any;
    }[];
  };
}

export interface ILastProductId {
  lastInsertedId: number;
}

export interface IProductPayload {
  productBrandId: string | null;
  productCategoryId: string | null;
  productTagIds: string[] | null;
  productViewOnline: string | null;
  productViewPos?: string | null;
  createdDateEnd: Date | null;
  createdDateStart: Date | null;
  searchText: string | null;
  createdDate: string | null;
  id: string | null;
}



export interface IVariantPayload {
  productId: string | null;
  productBrandId: string | null;
  productCategoryId: string | null;
  productTagIds: string[] | null;
  productViewOnline: string | null;
  productViewPos?: string | null;
  createdDateEnd: Date | null;
  createdDateStart: Date | null;
  searchText: string | null;
  createdDate: string | null;
  id: string | null;
}

export interface IModifierPayload {
  productBrandId: string | null;
  productCategoryId: string | null;
  productTagIds: string[] | null;
  modifierViewOnline: string | null;
  createdDateEnd: Date | null;
  createdDateStart: Date | null;
  searchText: string | null;
  createdDate: string | null;
  id: string | null;
}

export interface IModifierGroupPayload {
  productBrandId: string | null;
  productCategoryId: string | null;
  productTagIds: string[] | null;
  modifierViewOnline: string | null;
  createdDateEnd: Date | null;
  createdDateStart: Date | null;
  searchText: string | null;
  createdDate: string | null;
  id: string | null;
}




export interface ICategoryPayload {
  id?: string | null; 
  departmentId: string;
  coursingId: string;
  roleId: string[] | null;
  taxeId: string;
  createdDateEnd: Date | null;
  createdDateStart: Date | null;
  searchText: string;
  numberOfLength: number| null;
  isActive: boolean | null;
  categoryIsLooping: string | null;
  createdDate: string | null;
}

export interface IUpdateStatuInvoicePayload {
  id: string;
  mainStatus: string;
  po_number: string;
  amount_paid?: number;
  due_amount?: number;
  Mode?: string;
}

export interface ISearchPayload {
  searchText: string;
}

export interface IModifier {
  modifierName: string;
  modifierShortDescription: string;
  modifierLongDescription: string;
  modifierConversionUnit: number[];
  productBrandId: string;
  productCategoryId: string;
  productTagIds: number[];
  modifierViewOnline: boolean; 
  productPrinterIds: number[];
  productIcon: string;
  modifierImg: string;
  productButtonColor: string;
  productBarcode: string;
  isActive: boolean;
  productDetailsIsLooping: boolean;
  productsDetailsLoopingConstant: string;
  modifierCanSell: boolean;
  modifierPrice: string;
  mainCatId: string,
  loopingDetails?:{
    tableName: string;
    shortTableName: string;
    tableColumns: {
      name: string;
      type: string;
      columnField: string;
      options: string[];
      value: any;
    }[];
  };
}

export interface IModifierPopUp {
  id: number;
  modifierName: string;
  modifierShortDescription: string;
  modifierLongDescription: string;
  modifierConversionUnit: number[];
  productBrandId: string;
  productCategoryId: string;
  productTagIds: number[];
  modifierViewOnline: boolean; 
  productPrinterIds: number[];
  productIcon: string;
  modifierImg: string;
  productButtonColor: string;
  productBarcode: string;
  isActive: boolean;
  productDetailsIsLooping: boolean;
  productsDetailsLoopingConstant: string;
  productsDetailsLoopingProductId: string;
  modifierCanSell: boolean;
  modifierPrice: string;
  productMainCategoryId: string,
  loopingDetails?:{
    tableName: string;
    shortTableName: string;
    tableColumns: {
      name: string;
      type: string;
      columnField: string;
      options: string[];
      value: any;
    }[];
  };
}

export interface ModifierInfo {
  modifier_id: number;
  overwrite: boolean;
  overwrite_price: number | null;
}

export interface ProductInfo {
  product_id: string;
  productName?: string;  
  price?: number | null;
  pos?: boolean;
  online?: boolean; 
}

export interface IModifierGrp {
  modifierGroupName: string;
  minimum?: number;
  maximum?: number;
  categoryId: string;
  modifiers:  ProductInfo[];
  isActive: boolean;
}



export interface IModifierGroup {
  modifierGroupName: string;
  modifierCategoryId: string;
  minimum: number;
  maximum: number;
  modifierLongDescription: string;
  modifiers:  ModifierInfo[];
  isActive: boolean;
}

export interface IModifierGroupPopUp {
   id: string;
  modifierCategoryId?: string;
  minimum: number;
  maximum: number;
  order?: number; 
  modifierGroupName?: string;
  modifierLongDescription?: string;
  modifiers?:ModifierInfo[];
  isActive?: boolean;
  required?: boolean;
}

export interface IModifierGrpPopUp {
   id: string;
  categoryId?: string;
    modifierGroupId?: string; 
  modifierGroupName?: string;
   minimum?: number | string;
  maximum?: number | string;
  modifiers?:ProductInfo[];
  isActive?: boolean;
  required?: boolean;
  order?:number;
}


export interface ISearchIsActivePayload {
  searchText: string;
  isActive: boolean | null;
}

export interface ISearchRoutePayload {
  searchText: string;
 id: string | null;
}

export interface ILoopingTableListPayload {
  searchText: string;
  id: string;
  role?: string[]; 
}

export interface IInvoiceListPayload {
  searchText: string;
  id: string;
  quoteWorkOrderCustomerId: string;
  quoteWorkOrderCustomerProjectId: string;
  productId?: string;
}

export interface IPriceHistoryPayload {
  productName: string;
  transferTypeFrom: string;
  transferTypeTo: string;
}

export interface IWorkOrderHistoryPayload {
  id: string;
}

export interface IAssignDriverPayload {
  id: string;
}


export interface IInvoiceHistoryPayload {
  id: string;
}

export interface ICustomerTransactionPayload {
  searchText: string;
  customerId: string;
  projectId: string;
}

export interface ICustomerProjectPayload {
  searchText: string;
  customerId: string;
  id: string;
}

export interface IWorkOrderByCustomerProjectPayload {
  searchText: string;
  quoteWorkOrderCustomerId: string;
  quoteWorkOrderCustomerProjectId: string | null;
}

export interface ISelectCustomerPayload {
  quoteWorkOrderCustomerId: string;
}

export interface IUpdateWorkOrderByCustomerProjectPayload {
  id: number;
  quoteWorkOrderCustomerId: string;
  quoteWorkOrderCustomerProjectId: string;
}

export interface IRemovedorkOrderByCustomerProjectPayload {
  id: string;
  quoteWorkOrderCustomerId: string;
}

export interface ILoopingTablePayload {
  tableName: string;
}

export interface IGetByCategoryPayload {
  categoryId: string;
}

export interface IGetByCategoryArrayPayload {
  parent_ids: number[];
}

export interface ISubCategory {
  id: number;
  categoryName: string;
  subCatDescription: string;
  subCatImg: string;
  subIsMain: boolean;
  isActive: boolean;
  mainCatId: number;
  parentIds: number[];
  parent_ids: number[];
  categoryIsLooping: string;
  categoryLoopingConstant: string;
}

export interface ICategoryFilterPayload {
  searchText: string;
  numberOfLength: number;
  isActive: boolean | null;
}

export interface ILoopingTable {
  id: string;
  tableName: string;
  shortTableName: string;
  tableColumns: { name: string, type: string, columnField: string, options?: string[]}[];
}

export interface ILoopingWithDataTable {
  id: string;
  tableName: string;
  shortTableName: string;
  tableColumns: { 
    name: string; 
    type: string; 
    columnField: string; 
    options?: string[]; 
    value?: string | []; 
  }[];
  [key: string]: any; 
}

export interface ICustomer {
  id: number; 
  customerFirstName: string;
  customerLastName: string;
  customerMobileNum: string;
  customerEmail: string;
  customerProvince: string;
  customerCity: string;
  customerPostalCode: string;
  customerStreetName: string;
  customerStreetNumber: string;
  customerDescription: string;
  customerCompanyName: string;
  customerCompanyPhoneNumebr: string;
  customerCompanyEmail: string; 
  customerPreferTimeToCall: string;
  customerImg: string;
}

export interface IShop {
  id: number; 
  customerFirstName: string;
  customerLastName: string;
  customerMobileNum: string;
  customerEmail: string;
  customerProvince: string;
  customerCity: string;
  customerPostalCode: string;
  customerStreetName: string;
  customerStreetNumber: string;
  customerDescription: string;
  customerCompanyName: string;
  customerCompanyPhoneNumebr: string;
  customerCompanyEmail: string; 
  customerPreferTimeToCall: string;
  customerImg: string;
  route_ids: string;
  product_ids: string;
}




export interface IShopProduct {
  id: number;
  shop_id: number;
  product_id: number;
  product_name?: string;
  custom_price?: number | null;
}

export interface IVendor {
  id: number; 
  customerFirstName: string;
  customerLastName: string;
  customerMobileNum: string;
  customerEmail: string;
  customerProvince: string;
  customerCity: string;
  customerPostalCode: string;
  customerStreetName: string;
  customerStreetNumber: string;
  customerDescription: string;
  customerCompanyName: string;
  customerCompanyPhoneNumebr: string;
  customerCompanyEmail: string; 
  customerPreferTimeToCall: string;
  customerImg: string;
  send_email_notification?: boolean;

}

export interface IBill {
  id: number; 
  vendorId:  number;
  productId: number;
  buyingPrice: number;
  sellingPrice: number;
  count: number;
  tax: number;
  vendor: IVendor;
  product_details: IProduct;
}

export interface TimeSlot {
  startTime: string;
  endTime: string;
  hourlySalary: string;
}

export interface Availability {
  day: string;
  timeSlots: TimeSlot[];
}

export interface IDriver {
  id: number;
  driverMobileNum: string;
  driverFirstName: string;
  driverLastName: string;
  driverImg: string;
  driverCity: string;
  driverAddress: string;
  driverAltMobileNum: string;
  driverEmail: string;
  driverDescription: string;
  driverUserRole: string;
  driverUserName: string;
  driverPassWord: string;
  availability: Availability[];
}

export interface IAssignDrivers {
  id: number;
  work_order_id: number;
  assign_to: string; // This should be an array, updating below
  created_by: string;
  updated_by: string;
  created_at: string;
  updated_at: string;
  assignedDrivers?: IDriver[]; // New: Include assigned driver details
  updatedByUser?: IUser; // New: Include updated by user details
}

export interface ICustomerTransaction {
  id: number; 
  transactionName: string;
  customerId: string;
  transactionAmount: string;
  transactionDescription: string;
  transactionCollection: string; 
  transactionCollectionDate: string;
  istransactionReminder: boolean;
  transactionReminderDate: string;
  transactionReminderMedia: string[]; 
  created_at: string;
  projectId: string;
}

export interface ICustomerProject {
  id: number; 
  projectName: string;
  created_at: string;
  customerId: string;
  projectType: string;
  projectDomainName: string;
  projectPhoneNumber: string;
  projectProvince:string;
  projectCity: string;
  projectPostalCode: string;
  projectStreetNumber: string;
  projectStreetName: string;
  projectStartDate: string;
  projectEstimatedEndDate: string;
  projectProposalDate: string;
  projectUploadProposal: string;
  workOrderIds: string;
  projectDescription: string;
  projectEmail: string;
}

export interface ProductSale {
  productName: string;
  productDescription: string;
  quantity: number;
  price: number;
  tax: number;
  taxAmount: number;
  total: number;
  unitTotalWithDiscount: number;
  productId?: string;
}

export interface BillProductSale {
  productName: string;
  productDescription: string;
  quantity: number;
  buyPrice: number;
  sellprice: number;
  tax: number;
  taxAmount: number;
  total: number;
  unitTotalWithDiscount: number;
}



export interface IQuoteWorkOrder {
  id: number;
  quoteWorkOrderCompanyId: number;
  quoteWorkOrderCustomerId: string;
  quoteWorkOrderNo: string;
  quoteWorkOrderIssueDate: string | null;
  quoteWorkOrderDueDate: string | null; 
  quoteWorkOrderAmount: number | null;
  quoteWorkOrderStatus: number;
  quoteWorkOrderSale: ProductSale[];
  quoteWorkOrderDiscount: string;
  quoteWorkOrderSubTotal: string;
  quoteWorkOrderSaleGrandTotal: string;
  quoteWorkOrderSaleDiscountDescription: string | null;
  customer: ICustomer;
  company: ICompanyDetails;
  created_at: string;
  quoteWorkOrderCustomerProjectId: string;
  isInvoice: boolean;
  invoiceId: number;
  Mode: string;
  Customer_paid: number;
  Change: number;

}

export interface IBills {
  id: number;
  quoteWorkOrderCompanyId: number;
  quoteWorkOrderCustomerId: string;
  quoteWorkOrderNo: string;
  quoteWorkOrderIssueDate: string | null;
  quoteWorkOrderDueDate: string | null; 
  quoteWorkOrderAmount: number | null;
  quoteWorkOrderStatus: number;
  quoteWorkOrderSale: BillProductSale[];
  quoteWorkOrderDiscount: string;
  quoteWorkOrderSubTotal: string;
  quoteWorkOrderSaleGrandTotal: string;
  quoteWorkOrderSaleDiscountDescription: string | null;
  customer: IVendor;
  company: ICompanyDetails;
  created_at: string;
  quoteWorkOrderCustomerProjectId: string;
  isInvoice: boolean;
  invoiceId: number;
}

export interface IInvoice {
  id: number;
  work_order_id: number;
  InvoiceNo: string;
  Mode: string;
  po_number: string;
  payment_id: string;
  quoteWorkOrderCompanyId: number;
  quoteWorkOrderCustomerId: string;
  quoteWorkOrderNo: string;
  quoteWorkOrderIssueDate: string | null;
  quoteWorkOrderDueDate: string | null; 
  quoteWorkOrderAmount: number | null;
  quoteWorkOrderStatus: number;
  quoteWorkOrderSale: ProductSale[];
  quoteWorkOrderDiscount: string;
  quoteWorkOrderSubTotal: string;
  quoteWorkOrderSaleGrandTotal: string;
  quoteWorkOrderSaleDiscountDescription: string | null;
  customer: ICustomer;
  order_tickets?: IOrderTicket[];
  company: ICompanyDetails;
  project: ICustomerProject;
  drivers: IDriver;
  created_at: string;
  due_amount: number | null;
  amount: number | null;
  amount_paid: number | null;
  assign_driver: IAssignDrivers;
  Customer_paid: number;
  Change: number;
}

export interface IOrderTicket {
  id: number;       // invoice/order ID
  wp_page_id?: number;    // event page ID
  event_id: number;       // event ID
  ticket_code: string;    // unique ticket code
  qr_token: string;       // UUID for QR code
  qr_path?: string;
  booked_quantity: number;
  used_quantity: number;
  status: string; 
  
  event_name?: string;       // fetched from variantDetails table
  customer_name?: string;    // fetched from order -> customer
  invoice_no?: string;    
  created_at?: string;

  scannedUser?: string;
  scannedDate?: string;
  scannedGate?: string;
}


export interface IProductPopUP {
  id: string;
  productName: string;
  modelNo?: string;
  phoneType: string;
  productShortDescription: string;
  productLongDescription: string;
  productConversionUnit: number[];
  saleTypeId?: number[];
  stockManagementType?: string;
  productBrandId: number | null;
  productCategoryId: number;
  ProductCategoryLevel: number;
  productTagIds: number[];
  productViewOnline: boolean;
  productViewPos?: boolean;
  productPrinterIds: number[];
  productIcon: string;
  productImg: string;
  productButtonColor: string;
  productBarcode: string;
  productManualBarcode?: string;
  isActive: boolean;
  isSerialize?: boolean;
  isModifier?: boolean;
  productDetailsIsLooping: boolean;
  productsDetailsLoopingConstant: string;
  productsDetailsLoopingProductId: string;
  productCanSell: boolean;
  productMainCategoryId: string;
  loopingDetails?:{
    tableName: string;
    shortTableName: string;
    tableColumns: {
      name: string;
      type: string;
      columnField: string;
      options: string[];
      value: any;
    }[];
  }

}

export interface IEventPopUP {

  id: string;
  name: string;
  startDateTime: Dayjs | null;
  endDateTime: Dayjs | null;
  modelNo?: string;
  type: string;
  shortDescription: string;
  longDescription: string;
  conversionUnit: number[];
  saleTypeId?: number[];
  stockManagementType?: string;
  brandId: number | null;
  categoryId: number;
  categoryLevel: number;
  tagIds: number[];
  viewOnline: boolean; // Assuming this should be a boolean
  viewPos: boolean;
  printerIds: number[];
  icon: string;
  img: string;
  buttonColor: string;
  barcode: string;
  manualBarcode?: string;
  isActive: boolean;
  isSerialize?: boolean;
  isModifier?: boolean;
  price: string;
  salePrice : string;
  offerPrice? : string;
  qty? : number;
  orderNumber: string;
  modifierGroupId: ModifierGroupSelection[],
  hasVariants: boolean;
  variantIds: string; 
  isLooping: boolean;
  loopingConstant: string;
  loopingProductId: string;
  stock_count?: number;
  available_stock?: number;
  phoneLoopingDetails?: {
    productId: string;
    phoneType: string;
    phoneColor: string;
    phoneLoopingId: number;
  };
  computerLoopingDetails?: {
    productId: string;
    computerModel: string;
    computerRam: string;
    computerLoopingId: number;
  };
  canSell: boolean;
  mainCategoryId: string;
  loopingDetails?:{
    tableName: string;
    shortTableName: string;
    tableColumns: {
      name: string;
      type: string;
      columnField: string;
      options: string[];
      value: any;
    }[];
  };
 wp_page_id?: string | number;
  event_slug?: string;
  slug?: string;
  max_quantity?: number;
  sold_quantity?: number;
  booking_open_at?: Dayjs | null;
  booking_close_at?: Dayjs | null;
  includes_food?: boolean;
  expecting_participants?: number;
  

  
}


export interface IEmail {
  id: number; 
  to: string;
  subject: string;
  message: string;
  invoice: string;
}

export interface IText {
  id: number; 
  to: string;
  message: string;
  
}

export interface ICall {
  id: number; 
  call_date: string;
  notes: string;
  call_outcome: string;
  priority: string;
  next_follow_up_date: string;
  assigned_to?: string;
  user?: IDriver;
}

export interface INote {
  id: number; 
  to: string;
  subject: string;
  message: string;
  
}

export interface INoteEmail {
  id: number; 
  note_subject: string;
  note_message: string;
  
}

export interface IEmailTemplate {
  id: number;
  template_name: string;
  subject: string;
  message: string;
}

export interface INoteTemplate {
  id: number;
  note_title: string;
  subject: string;
  note_message: string;
}

export interface ISerializedItem {
  id?: number;
  productId: number;
  productName?: string;
  IMEInO?: string | null;
  SERIALNO?: string | null;
  modelNo?: string | null;
  notes?: string | null;
  created_by?: number;
  updated_by?: number | null;
  created_at?: string | null;
  updated_at?: string | null;
  bill?: IBills;
  billNo?: string;
  buyingPrice?: string;
  vendorName?: string;
  vendorId?:number;
  isSold: boolean;
}

export interface ISold {
  id: number;              
  invoiceNo: string;      
  productId: number;     
  productName: string;    
  imei?: string | null;    
  SERIALNO?: string | null;
  modelNo?: string | null; 
  buyingPrice: number;     
  sellingPrice: number;  
  soldFrom: string;     
  quantity: number;   
  customerId: number;       
  customerName?: string;    
  vendorName?: string;      
  notes?: string | null;   
  createdBy: number;      
  updatedBy: number;       
  created_at: string;      
  updated_at: string;      
}


export interface IShopOrderItem {
  product_id: number;
  name: string;
  qty: number;
  price: number;
  subtotal: number;
}

export interface IShopOrder {
  id: number;
  shop_id: number;
  items: IShopOrderItem[];
  total: number;
  status: 'pending' | 'confirmed' | 'processing' | 'delivered' | 'cancelled';
  notes?: string | null;
  portal_note?: string | null;
  order_date?: string | null; 
  created_at: string;
  updated_at: string;
}

export interface IShopInvoicePayment {
  id: number;
  shop_invoice_id: number;
  amount: number;
  payment_method: string;
  notes?: string | null;
  payment_date: string;
  created_at: string;
}

export interface IShopInvoice {
  id: number;
  invoice_number: string;
  shop_order_id: number;
  shop_id: number;
  items: IShopOrderItem[];
  subtotal: number;
  total: number;
  amount_paid: number;
  balance_due: number;
  payment_status: 'unpaid' | 'partial' | 'paid';
  notes?: string | null;
  invoice_date: string;
  due_date?: string | null;
  created_at: string;
  shop?: IShop;
  shop_order?: IShopOrder;
  payments?: IShopInvoicePayment[];
}

export interface IProductInventory {
  id?: number;
  productId: number;
  productName: string;
  isSerialized: boolean;     // true / false
  totalStock: number;
  manualStock : number;
  finalStock: number;
  notes?: string | null;
  created_by?: number;
  updated_by?: number | null;
  created_at?: string | null;
  updated_at?: string | null;
  avgBuyPrice?: number;          
  netCost?: number;               
  HST?: number;             
  sellingPrice?: number;  
  

  // Relation
  serialized?: ISerializedItem[];
}

// ─── Digital Signage CMS ──────────────────────────────────────────────────

export interface IDevice {
  id: number;
  uuid: string;
  company_id: number | null;
  company?: { id: number; name: string } | null;
  device_name: string;
  device_code: string;
  location: string | null;
  playlist_id: number | null;
  playlist?: { id: number; name: string; version: number } | null;
  playlist_group_id: number | null;
  playlist_group?: {
    id: number;
    name: string;
    playback_mode: string;
    is_active: boolean;
    playlists_count?: number;
  } | null;
  status: "online" | "offline" | "disabled";
  is_disabled?: boolean;
  disabled_reason?: string | null;
  disabled_at?: string | null;
  last_seen_at: string | null;
  app_version: string | null;
  // App version + install tracking (2026-08).
  installed_app_version?: string | null;
  app_updated_at?: string | null;
  app_update_status?: "up_to_date" | "update_available" | "update_pending" | "update_failed" | "not_reported" | string | null;
  assigned_app_version?: string | null;
  last_update_error?: string | null;
  monthly_rate?: number | null;
  activation_date?: string | null;
  subscription_status?: "trial" | "active" | "suspended" | "cancelled" | string | null;
  // Monitoring snapshot (2026-06).
  player_type?: "android" | "web" | string | null;
  storage_used?: number | null;
  storage_total?: number | null;
  current_media_id?: number | null;
  current_media_name?: string | null;
  last_sync_at?: string | null;
  last_error?: string | null;
  health_status?: "healthy" | "warning" | "critical" | string | null;
  latest_screenshot_path?: string | null;
  // Browser/Windows Player runtime metadata snapshot (2026-10). Null for
  // Android devices and web devices that predate the feature.
  os?: string | null;
  browser?: string | null;
  browser_version?: string | null;
  screen_width?: number | null;
  screen_height?: number | null;
  orientation?: "landscape" | "portrait" | string | null;
  device_pixel_ratio?: number | null;
  user_agent?: string | null;
  metadata_updated_at?: string | null;
  force_refresh?: boolean;
  // App-update tracking (2026-06).
  app_version_code?: number | null;
  update_channel?: "stable" | "beta" | "test" | string | null;
  last_update_check_at?: string | null;
  installed_release_id?: number | null;
  update_status?: string | null;
  // Assignment mirror (2026-08).
  update_policy?: "optional" | "automatic" | "mandatory" | string | null;
  update_install_mode?: "immediate" | "scheduled" | "maintenance_window" | string | null;
  update_progress?: number | null;
  update_scheduled_at?: string | null;
  last_update_attempt_at?: string | null;
  assigned_release_id?: number | null;
  installed_version?: string | null;
  assigned_version?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface IDeviceCommand {
  id: number;
  command: "force_refresh" | "clear_cache" | "restart_player" | "request_screenshot" | string;
  payload: Record<string, unknown> | null;
  status: "pending" | "sent" | "completed" | "failed";
  result_message: string | null;
  created_by: { id: number; name: string } | null;
  created_at: string | null;
  sent_at: string | null;
  executed_at: string | null;
}

export interface IDeviceEvent {
  id: number;
  event_type: string;
  message: string | null;
  metadata: Record<string, unknown> | null;
  created_at: string | null;
}

export interface IDeviceHeartbeat {
  id: number;
  playlist_version: number | null;
  app_version: string | null;
  player_type: string | null;
  storage_used: number | null;
  storage_total: number | null;
  current_media_id: number | null;
  current_media_name: string | null;
  ip_address: string | null;
  user_agent: string | null;
  created_at: string | null;
}

export interface IMedia {
  id: number;
  company_id?: number | null;
  company?: { id: number; name: string } | null;
  file_name: string;
  original_name: string;
  media_type: "image" | "video";
  mime_type: string;
  file_size: number;
  duration: number | null;
  checksum: string;
  path?: string;
  url: string;
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
}

/** Stable transition identifier (see Player/transitions.ts for the catalogue). */
export type TransitionId = string;
/** Stable easing identifier. */
export type TransitionEasing =
  | "linear" | "ease" | "ease_in" | "ease_out" | "ease_in_out";

export interface IPlaylistItem {
  id: number;
  playlist_id: number;
  // V2 — items are either MEDIA or TEMPLATE. Server always sets
  // item_type; older payloads default to MEDIA.
  item_type?: "MEDIA" | "TEMPLATE";
  media_id: number | null;
  template_id?: number | null;
  duration: number | null;
  sort_order: number;
  // Per-item transition (raw/unresolved — the editor round-trips these).
  transition_in?: TransitionId | null;
  transition_out?: TransitionId | null;
  transition_duration_ms?: number | null;
  transition_easing?: TransitionEasing | null;
  use_playlist_default_transition?: boolean;
  media?: IMedia;
  template?: {
    id: number;
    name: string;
    orientation: "landscape" | "portrait";
    version: number;
  } | null;
}

export type PlaylistDurationMode = "PLAY_FULL" | "PLAY_FOR_DURATION" | "PLAY_ONCE";

/* ---- Smart Menu Scheduling ---- */

export type MenuType =
  | "standard_playlist"
  | "default_menu"
  | "daily_special"
  | "time_based_menu"
  | "holiday_menu"
  | "promotional_campaign"
  | "pos_synced_menu"
  | "emergency_override";

export type MenuStatus =
  | "default"
  | "scheduled"
  | "live_now"
  | "upcoming"
  | "expired"
  | "draft"
  | "pos_synced"
  | "sync_error"
  | "override_active";

/** Day-of-week bitmask (matches the backend). Mon=1 .. Sun=64. */
export const DOW = {
  MON: 1, TUE: 2, WED: 4, THU: 8, FRI: 16, SAT: 32, SUN: 64,
} as const;
export const DOW_ORDER: Array<{ key: keyof typeof DOW; label: string; short: string }> = [
  { key: "MON", label: "Monday", short: "Mon" },
  { key: "TUE", label: "Tuesday", short: "Tue" },
  { key: "WED", label: "Wednesday", short: "Wed" },
  { key: "THU", label: "Thursday", short: "Thu" },
  { key: "FRI", label: "Friday", short: "Fri" },
  { key: "SAT", label: "Saturday", short: "Sat" },
  { key: "SUN", label: "Sunday", short: "Sun" },
];

export interface IScheduleConflict {
  item_id: number;
  menu: string;
  menu_id: number;
  days: string[];
  start_time: string | null;
  end_time: string | null;
  start_date: string | null;
  end_date: string | null;
  device_ids: number[];
}

export interface ISchedulePreview {
  at: string;
  timezone: string;
  rule: string;
  override_active: boolean;
  playlists: Array<{ id: number; name: string | null; menu_type: MenuType | null }>;
}

/**
 * One row of the company-wide Menu Schedules overview. Each row is a
 * scheduled menu = a PlaylistGroupItem (a playlist scheduled inside a group).
 * Screens are the group's assigned devices; menu_type lives on the playlist.
 */
export type MenuScheduleStatus = "active" | "upcoming" | "ended" | "disabled";

export interface IMenuScheduleRow {
  id: number;                 // playlist_group_item id
  group_id: number;
  group_name: string;
  company_id: number | null;
  company: { id: number; name: string } | null;
  playlist_id: number;
  playlist: { id: number; name: string; menu_type: MenuType | null; is_active: boolean } | null;
  menu_type: MenuType | null;
  is_active: boolean;
  days_of_week: number | null;
  start_time: string | null;
  end_time: string | null;
  start_date: string | null;
  end_date: string | null;
  priority: number;
  playback_mode: PlaylistGroupPlaybackMode;
  screens_count: number;
  status: MenuScheduleStatus;
  updated_at: string | null;
}

export interface IHolidaySuggestion {
  key: string;
  name: string;
  date: string;
  province: string;
  suggested_menu_type: MenuType;
}

export interface IPlaylistVersionEntry {
  id: number;
  playlist_id: number;
  version: number;
  label: string | null;
  created_by: number | null;
  created_at: string | null;
  creator?: { id: number; name?: string; username?: string } | null;
}

export interface IPlaylist {
  id: number;
  company_id?: number | null;
  // is_active surfaces on the assigned company so the Playlist Edit
  // picker can render an "Inactive" chip without a second lookup.
  company?: { id: number; name: string; is_active?: boolean } | null;
  // Single "assigned group" id, surfaced from the playlist_group_items
  // pivot. Present only when the API eager-loads groups (Playlist show()).
  // null => "— No Playlist Group —".
  playlist_group_id?: number | null;
  playlist_group?: {
    id: number;
    name: string;
    playback_mode: PlaylistGroupPlaybackMode;
    is_active: boolean;
    company_id?: number | null;
  } | null;
  name: string;
  description: string | null;
  menu_type?: MenuType;
  duration_mode?: PlaylistDurationMode | null;
  duration_minutes?: number | null;
  // Playlist-level default item transition.
  default_transition?: TransitionId | null;
  default_transition_duration_ms?: number | null;
  default_transition_easing?: TransitionEasing | null;
  version: number;
  is_active: boolean;
  items_count?: number;
  devices_count?: number;
  items?: IPlaylistItem[];
  // Optional list-page enrichment (present only when the server computes it).
  menu_status?: MenuStatus;
  current_menu?: { id: number; name: string } | null;
  next_menu?: { id: number; name: string } | null;
  next_change_at?: string | null;
  assigned_device_count?: number;
  pos_sync_status?: "synced" | "error" | "none" | null;
  created_at?: string;
  updated_at?: string;
}

export type PlaylistGroupPlaybackMode = "SEQUENTIAL" | "LOOP_ALL" | "RANDOM";

export interface IPlaylistGroupItem {
  id: number;
  playlist_group_id: number;
  playlist_id: number;
  sort_order: number;
  duration_minutes: number | null;
  is_active: boolean;
  start_date?: string | null;
  end_date?: string | null;
  start_time?: string | null;
  end_time?: string | null;
  days_of_week?: number | null;
  priority?: number | null;
  // Per-assignment "transition to next playlist" (raw/unresolved).
  transition_to_next?: TransitionId | null;
  transition_duration_ms?: number | null;
  transition_easing?: TransitionEasing | null;
  use_group_default_transition?: boolean;
  playlist?: IPlaylist;
}

export interface IPlaylistGroup {
  id: number;
  company_id?: number | null;
  company?: { id: number; name: string; is_active?: boolean } | null;
  name: string;
  description: string | null;
  playback_mode: PlaylistGroupPlaybackMode;
  // Group-level default playlist-to-playlist transition.
  default_playlist_transition?: TransitionId | null;
  default_playlist_transition_duration_ms?: number | null;
  default_playlist_transition_easing?: TransitionEasing | null;
  is_active: boolean;
  total_duration: number;
  playlists_count?: number;
  devices_count?: number;
  items?: IPlaylistGroupItem[];
  created_by?: number | null;
  creator?: { id: number; name: string } | null;
  created_at?: string;
  updated_at?: string;
}

